import { observable, action, makeObservable } from 'mobx';
import axios from 'axios';

class dragStore {
  drag_enabled=false;
  drag_manual_enabled=false;
  drag_manual_data= {};
  drag_type="";
  drag_source= {};
  dragging=false;

  par=null;
  constructor(par) {
    makeObservable(this,{
      drag_enabled:observable,
      drag_type:observable,
      drag_source:observable,
      dragging:observable,
      drag_manual_enabled:observable,
      drag_manual_data:observable,
    });
    this.par=par;
  }
  toggleDrag() {
    this.drag_enabled=!this.drag_enabled;
  }
  drop(type,source,movePos,target) {

  }

}

/*decorate(dragStore,{
  drag_enabled:observable,
  drag_type:observable,
  drag_source:observable,
  dragging:observable,
  drag_manual_enabled:observable,
  drag_manual_data:observable,
});*/

export default dragStore;
